module.exports = __webpack_public_path__ + "static/media/women-banner-1.7b0131c8.png";